import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "star-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.5973 3.70602C13.2867 3.08553 12.6506 2.69523 11.9567 2.69925C11.2628 2.70327 10.6314 3.10094 10.3279 3.72496L8.35018 7.79083L3.87965 8.46669C3.19354 8.57041 2.62581 9.05465 2.41517 9.71581C2.20454 10.377 2.38753 11.1004 2.8872 11.5819L6.14297 14.7192L5.40434 19.1799C5.29107 19.8644 5.57621 20.5539 6.1399 20.9585C6.70359 21.363 7.4481 21.4125 8.06039 21.0861L12.0502 18.9592L16.0642 21.0401C16.6802 21.3595 17.4242 21.3015 17.9832 20.8904C18.5423 20.4794 18.8195 19.7865 18.6982 19.1033L17.9083 14.6514L21.1278 11.4769C21.6219 10.9897 21.7966 10.2643 21.5784 9.60557C21.3601 8.94687 20.7869 8.46919 20.0996 8.37335L15.6216 7.74893L13.5973 3.70602Z" }, null, -1)
  ])))
}
export default { render: render }